export const isClearFiltersEnabled = (pagination) => {
  const isAnyFilterEnabled = Object.keys(pagination.filters).find(key => {
    return !!pagination.filters[key]
  })
  return !!(pagination.searchText || isAnyFilterEnabled)
}
